import React from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';
import { Form, TextArea } from 'semantic-ui-react';
import { BUTTON_CONFIGS } from '../../../config/serviceDeskConfigs';
import propTypes from 'prop-types';

function ModalCloseTicket(props) {
  // console.log("🚀 ~ ModalCloseTicket ~ props:", props, BUTTON_CONFIGS[props.idProject].detail)
  const [openModal, setopenModal] = React.useState(false);

  function toggle(props) {
    setopenModal(!openModal);
  }

  return (
    <React.Fragment>
      <Button
        {...BUTTON_CONFIGS[props.idProject].detail.btnPrimary}
        hidden={props.Ticket.CatStatusId !== 1 ? true : false}
        onClick={toggle}
      >
        {props.labels.details.btn_close_ticket.title}
      </Button>

      <Modal isOpen={openModal} >
        <ModalHeader>{props.labels.details.btn_close_ticket.titleModal}</ModalHeader>
        <ModalBody>
          <spam style={{ color: '#006cbb' }}><b>Tiket: {props.Ticket.TicketNumber}</b></spam>
          <Form>
            <TextArea placeholder='Tell us more' style={{ minHeight: 100 }}
              onChange={props.onChange}
            />
          </Form>
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'center' }}>
          <Button
            {...BUTTON_CONFIGS[props.idProject].detail.btnPrimary}
            disabled={props.disabledButton}
            onClick={() => { setopenModal(false); props.CancelTicket(); }}>
            {props.labels.details.btn_close_ticket.btn_confirm}
          </Button>{' '}
          <Button
            {...BUTTON_CONFIGS[props.idProject].detail.btnSecondary}
            onClick={() => { setopenModal(false); }}>
            {props.labels.details.btn_close_ticket.btn_cancel}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};

ModalCloseTicket.propTypes = {
  labels: propTypes.object,
  onCancel: propTypes.func
};

ModalCloseTicket.defaultProps = {
  onCancel: () => { },
  labels: {
    title: '',
    icon: '',
    btn_create: '',
    btn_cancel: ''
  }
};

export default ModalCloseTicket;